<template>
  <div>
    <customer-details>
      <template v-slot:default>
        <div>
          <h2 class="text--title mb-2 mt-6">残権利情報</h2>
          <v-card outlined class="pb-8">
            <Table
              :attr="{
                dense: true,
                'no-data-text': $t('rules.noData'),
                'item-key': 'id',
              }"
              ref="table"
              :itemsPerPage="30"
              :itemsPerPageOptions="[30, 60, 120, 480]"
              :headers="headers"
              :items="items"
            >
              <template v-slot:[`item.productTypeName`]="{ item }">
                {{ item.productName }}
              </template>
              <template v-slot:[`item.contractNumber`]="{ item }">
                {{ item.contractNumber || '' }}
              </template>
              <template v-slot:[`item.remainingSp`]="{ item }">
                {{ item.remainingSp | toThousands }}
              </template>
              <template v-slot:[`item.rightInJpy`]="{ item }">
                {{ item.rightInJpy | toThousands }}
              </template>
              <template v-slot:[`item.edit`]="{ item }">
                <v-btn v-if="item.contractNumber" icon @click="getUrl(item)">
                  <v-icon
                    x-large
                    color="#3AC1EE"
                    style="box-shadow: 0px 3px 6px #00000029"
                  >
                    mdi-pencil-circle</v-icon
                  >
                </v-btn>
              </template>
            </Table>
          </v-card>
        </div>
      </template>
    </customer-details>
  </div>
</template>
<script>
import CustomerDetails from '../CustomerDetails.vue';


import gql from 'graphql-tag';
import Table from '@/components/Table/index.vue';
import { goToContractDetail } from '@/constants/contractProductType';

export default {
  components: {
    Table,
    CustomerDetails,
  },
  name: 'customer-remaining-rights',
  data() {
    return {
      items: [],
    };
  },
  computed: {
    clientId () {
      return Number(this.$route.params.id)
    },
    headers () {
      return [
        {
          text: '商品名',
          value: 'productTypeName',
          width: '50px',
        },
        {
          text: '施設名',
          value: 'facilityName',
          width: '200px',
        },
        {
          text: 'SP残ポイント',
          value: 'remainingSp',
          width: '120px',
        },
        {
          text: '残権利金額',
          value: 'rightInJpy',
          width: '120px',
        },
        {
          text: '契約番号',
          value: 'contractNumber',
          width: '200px',
        },
        {
          text: '契約開始日',
          value: 'startDate',
          width: '120px',
        },
        {
          text: '契約満了日',
          value: 'endDate',
          width: '120px',
        },
        {
          text: '契約詳細',
          value: 'edit',
          align: 'right',
          width: '100px',
          sortable: false,
        },
      ];
    },
  },
  methods: {
    getUrl(item) {
      goToContractDetail(item.contractId);
    },
  },
  apollo: {
    load: {
      query: gql`query getRemainingRights($clientId: Int!) {
        getRemainingRights (clientId: $clientId) {
          items {
            productName
            facilityName
            clientId
            remainingSp
            rightInJpy
            contractId
            contractNumber
            startDate
            endDate
          }
        }
      }`,
      variables() {
        return {
          clientId: this.clientId,
        };
      },
      result({ data }) {
        this.items = data.getRemainingRights.items;
      },
      enabled() {
        return this.clientId > 0;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
